export default {"src":"/_next/static/media/mondial-logo-full-color-rgb.cb11ed12.svg","height":575,"width":550,"blurWidth":0,"blurHeight":0};